import { render, staticRenderFns } from "./InvoiceRedirectPage.vue?vue&type=template&id=7595937e&scoped=true&"
import script from "./InvoiceRedirectPage.vue?vue&type=script&lang=js&"
export * from "./InvoiceRedirectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7595937e",
  null
  
)

export default component.exports